import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/app/(main)/supplier-application/page.tsx");
